import { NavItem } from '../../nav/primitives/nav-item';
import { useMarketingNavItem } from './use-marketing-nav-item';

export const MarketingNavItem = () => {
  const item = useMarketingNavItem();
  return <NavItem item={item} />;
};
